/* Where the toast stack stands (Settings, Notifications, "Toast position").
   The stack's own rule (pixel-toast.module.css .stack) centres it at the top;
   these only move it, so top centre needs nothing here. In a sheet of its own
   so the toasts' stylesheet is not touched. The class is doubled: it has to
   win over .stack whichever of the two sheets the page loads last. */

.at.at[data-v="bottom"] {
  top: auto;
  bottom: 14px;
}

.at.at[data-h="left"] {
  left: 14px;
  transform: none;
  align-items: flex-start;
}

.at.at[data-h="right"] {
  right: 14px;
  left: auto;
  transform: none;
  align-items: flex-end;
}

/* at the bottom a toast comes in from below and leaves the way it came */
@starting-style {
  .at.at[data-v="bottom"] > * {
    transform: translateY(12px);
  }
}

.at.at[data-v="bottom"] > [data-leaving] {
  transform: translateY(8px);
}

@media (prefers-reduced-motion: reduce) {
  .at.at[data-v="bottom"] > [data-leaving] {
    transform: none;
  }
}
